// extracted by css-extract-rspack-plugin
module.exports =  {"root":"ConversationHeaderBanner__root___SLSt1","title":"ConversationHeaderBanner__title___ffniQ","content":"ConversationHeaderBanner__content___qym1U"};